import { HTMLProps, PropsWithChildren } from "react";
import styles from "./index.module.css";

interface IButtonProps
  extends PropsWithChildren,
    HTMLProps<HTMLButtonElement> {}

const Button = ({ children, onClick, style }: IButtonProps) => {
  return (
    <button style={style} className={styles.button} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
